"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importDefault(require("react"));
var AuthProfileMenu_1 = __importDefault(require("./AuthProfileMenu"));
var UnAuthProfileMenu_1 = __importDefault(require("./UnAuthProfileMenu"));
var ProfileMenu = function (_a) {
    var languages = _a.languages, defaultCurrency = _a.defaultCurrency, firstDepFreespins = _a.firstDepFreespins, firstDepPercents = _a.firstDepPercents, firstDepMaxBonus = _a.firstDepMaxBonus, WelcomeProfileBanner = _a.WelcomeProfileBanner, withReferral = _a.withReferral, promoLink = _a.promoLink;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    return (react_1.default.createElement(ui_components_1.Modal, { width: "100%", height: "100%", padding: "0" }, isAuth ? (react_1.default.createElement(AuthProfileMenu_1.default, { languages: languages, withReferral: withReferral, promoLink: promoLink })) : (react_1.default.createElement(UnAuthProfileMenu_1.default, { languages: languages, defaultCurrency: defaultCurrency, firstDepMaxBonus: firstDepMaxBonus, firstDepPercents: firstDepPercents, firstDepFreespins: firstDepFreespins, WelcomeProfileBanner: WelcomeProfileBanner, promoLink: promoLink }))));
};
exports.default = ProfileMenu;
